import GradientButton from "../../UI/buttonUI/GradientButton";
import GrayButton from "../../UI/buttonUI/GrayButton";
import Modal from "../../portal/Modal";

export const CheckSingleExpenseConfirmDialog = ({
  buttonStatus,
  closeDialog,
  checkLoading,
  handleCheck,
}) => {
  const message = buttonStatus
    ? "Are you sure you want to Accept this expense ?"
    : "Are you sure you want to Reject this expense ?";
  return (
    <Modal
      onClose={closeDialog}
      modalWidth="flex-center-align dialogBoxWrap"
      closeIcon={true}
    >
      <div className="px-12 2xs:max-sm:px-0">
        <p className="dialogBoxMsg">{message}</p>

        <div className="flex-center-align sm:mt-10 mt-4 gap-2">
          <GradientButton
            btnText={!checkLoading ? "Confirm" : "Loading..."}
            onClick={!checkLoading ? handleCheck : undefined}
          />
          <GrayButton btnText="Cancel" onClick={closeDialog} />
        </div>
      </div>
    </Modal>
  );
};
